import React, { useState, useEffect } from 'react';
import axios from 'axios';
import API from '../../services/api';
import useToast from './useToast';

const authH      = () => ({ Authorization: `Bearer ${localStorage.getItem('adminToken')}` });
const isDemoMode = () => localStorage.getItem('adminMode') === 'demo';

const DEMO_SUBS = [
  { _id:'s1',  name:'Sarah Chen',         email:'sarah.chen@example.com',       source:'website', status:'active', createdAt: new Date(Date.now()-1*3600000).toISOString()     },
  { _id:'s2',  name:'James Wright',       email:'james.wright@business.com',    source:'website', status:'active', createdAt: new Date(Date.now()-5*3600000).toISOString()     },
  { _id:'s3',  name:'Priya Ramasamy',     email:'priya.r@techcorp.com',         source:'website', status:'active', createdAt: new Date(Date.now()-12*3600000).toISOString()    },
  { _id:'s4',  name:'Marcus Williams',    email:'marcus.w@enterprise.com',      source:'website', status:'active', createdAt: new Date(Date.now()-1*86400000).toISOString()    },
  { _id:'s5',  name:'Elena Vasquez',      email:'elena.v@globalleaders.com',    source:'website', status:'active', createdAt: new Date(Date.now()-2*86400000).toISOString()    },
  { _id:'s6',  name:'David Kim',          email:'david.kim@innovate.io',        source:'website', status:'active', createdAt: new Date(Date.now()-3*86400000).toISOString()    },
  { _id:'s7',  name:'Fatima Al-Hassan',   email:'fatima.h@globalmed.org',       source:'website', status:'active', createdAt: new Date(Date.now()-5*86400000).toISOString()    },
  { _id:'s8',  name:'Robert Thompson',    email:'r.thompson@consultancy.com',   source:'website', status:'active', createdAt: new Date(Date.now()-7*86400000).toISOString()    },
  { _id:'s9',  name:'Amara Osei',         email:'amara.osei@africa.business',   source:'website', status:'active', createdAt: new Date(Date.now()-10*86400000).toISOString()   },
  { _id:'s10', name:'Lisa Tanaka',        email:'l.tanaka@tokyobiz.jp',         source:'website', status:'active', createdAt: new Date(Date.now()-14*86400000).toISOString()   },
  { _id:'s11', name:'Carlos Mendoza',     email:'c.mendoza@latamleaders.com',   source:'website', status:'active', createdAt: new Date(Date.now()-20*86400000).toISOString()   },
  { _id:'s12', name:'Nadia Petrov',       email:'nadia.p@eurobusiness.eu',      source:'website', status:'active', createdAt: new Date(Date.now()-25*86400000).toISOString()   },
];

export default function AdminSubscribers() {
  const [subs,    setSubs]    = useState([]);
  const [loading, setLoading] = useState(true);
  const [search,  setSearch]  = useState('');
  const [page,    setPage]    = useState(1);
  const PER = 10;
  const { addToast, ToastContainer } = useToast();

  const fetchSubs = async () => {
    setLoading(true);
    if (isDemoMode()) {
      setTimeout(() => { setSubs([...DEMO_SUBS]); setLoading(false); }, 400);
      return;
    }
    try {
      const r = await API.get('/subscribers', { headers: authH() });
      setSubs(r.data.data?.length ? r.data.data : [...DEMO_SUBS]);
    } catch { setSubs([...DEMO_SUBS]); }
    finally  { setLoading(false); }
  };

  useEffect(() => { fetchSubs(); }, []);

  const handleUnsubscribe = async (id, email) => {
    if (!window.confirm(`Unsubscribe ${email}?`)) return;
    if (isDemoMode()) {
      setSubs(prev => prev.filter(s => s._id !== id));
      addToast('Unsubscribed (demo)', 'success'); return;
    }
    try {
      await API.post('/subscribers/unsubscribe', { email }, { headers: authH() });
      addToast('Unsubscribed', 'success'); fetchSubs();
    } catch { addToast('Action failed', 'error'); }
  };

  const copyEmails = () => {
    const list = filtered.map(s => s.email).join('\n');
    navigator.clipboard.writeText(list).then(() => {
      addToast(`${filtered.length} emails copied to clipboard`, 'info');
    });
  };

  const filtered = subs.filter(s =>
    !search ||
    s.email.toLowerCase().includes(search.toLowerCase()) ||
    (s.name||'').toLowerCase().includes(search.toLowerCase())
  );
  const pages = Math.ceil(filtered.length / PER);
  const paged = filtered.slice((page-1)*PER, page*PER);

  /* Mini stats */
  const now   = Date.now();
  const month = new Date(new Date().getFullYear(), new Date().getMonth(), 1).getTime();
  const week  = now - 7*24*60*60*1000;
  const thisMonth = subs.filter(s => new Date(s.createdAt).getTime() >= month).length;
  const thisWeek  = subs.filter(s => new Date(s.createdAt).getTime() >= week).length;

  return (
    <div>
      <div className="page-header">
        <div>
          <h1 className="page-title">Subscribers</h1>
          <p className="page-subtitle">{subs.length} active subscribers</p>
        </div>
        <div className="page-actions">
          <button className="btn btn-secondary" onClick={copyEmails}>
            📋 Copy All Emails
          </button>
        </div>
      </div>

      {/* Mini stat cards */}
      <div className="stats-grid" style={{ marginBottom:24 }}>
        {[
          { label:'Total Active',  val: subs.length,   accent:'#c9a84c', icon:'M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z' },
          { label:'This Month',    val: thisMonth,      accent:'#4ade80', icon:'M8 7V3m8 4V3m-9 8h10M5 21h14a2 2 0 002-2V7a2 2 0 00-2-2H5a2 2 0 00-2 2v12a2 2 0 002 2z' },
          { label:'This Week',     val: thisWeek,       accent:'#60a5fa', icon:'M13 7h8m0 0v8m0-8l-8 8-4-4-6 6' },
          { label:'Filtered View', val: filtered.length,accent:'#a78bfa', icon:'M3 4a1 1 0 011-1h16a1 1 0 011 1v2.586a1 1 0 01-.293.707l-6.414 6.414a1 1 0 00-.293.707V17l-4 4v-6.586a1 1 0 00-.293-.707L3.293 7.293A1 1 0 013 6.586V4z' },
        ].map(s => (
          <div key={s.label} className="stat-card"
            style={{ '--accent':s.accent, '--icon-bg':`${s.accent}18` }}>
            <div className="stat-card-icon">
              <svg width="22" height="22" fill="none" viewBox="0 0 24 24"
                stroke="currentColor" strokeWidth="1.8">
                <path strokeLinecap="round" strokeLinejoin="round" d={s.icon}/>
              </svg>
            </div>
            <div className="stat-card-val">
              {loading ? '—' : s.val.toLocaleString()}
            </div>
            <div className="stat-card-lbl">{s.label}</div>
          </div>
        ))}
      </div>

      <div className="table-card">
        <div className="table-header">
          <span className="table-title">Subscriber List</span>
          <div className="table-controls">
            <div className="search-box">
              <svg width="15" height="15" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2">
                <circle cx="11" cy="11" r="8"/><path strokeLinecap="round" d="M21 21l-4.35-4.35"/>
              </svg>
              <input placeholder="Search by name or email…" value={search}
                onChange={e => { setSearch(e.target.value); setPage(1); }}/>
            </div>
            {search && (
              <button className="btn btn-sm btn-secondary"
                onClick={() => { setSearch(''); setPage(1); }}>
                Clear
              </button>
            )}
          </div>
        </div>

        <div style={{ overflowX:'auto' }}>
          <table className="data-table">
            <thead>
              <tr>
                <th style={{ width:40 }}>#</th>
                <th>Subscriber</th>
                <th>Email</th>
                <th>Source</th>
                <th>Joined</th>
                <th>Status</th>
                <th style={{ width:90, textAlign:'right' }}>Actions</th>
              </tr>
            </thead>
            <tbody>
              {loading ? (
                Array.from({length:5}).map((_,i)=>(
                  <tr key={i}>{[40,150,200,80,100,70,90].map((w,j)=>(
                    <td key={j}><div style={{ height:12, background:'var(--card2)', borderRadius:3, animation:'pulse 1.4s infinite' }}/></td>
                  ))}</tr>
                ))
              ) : paged.length === 0 ? (
                <tr><td colSpan={7}>
                  <div className="empty-state">
                    <div className="empty-icon">
                      <svg width="26" height="26" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="1.5">
                        <path strokeLinecap="round" strokeLinejoin="round" d="M17 20h5v-2a3 3 0 00-5.356-1.857M17 20H7m10 0v-2c0-.656-.126-1.283-.356-1.857M7 20H2v-2a3 3 0 015.356-1.857M7 20v-2c0-.656.126-1.283.356-1.857m0 0a5.002 5.002 0 019.288 0M15 7a3 3 0 11-6 0 3 3 0 016 0z"/>
                      </svg>
                    </div>
                    <div className="empty-title">No subscribers found</div>
                    <div className="empty-sub">
                      {search ? 'Try a different search term.' : 'Subscribers appear here once people sign up on the site.'}
                    </div>
                  </div>
                </td></tr>
              ) : paged.map((s, i) => (
                <tr key={s._id}>
                  <td style={{ color:'var(--white40)', fontSize:'.78rem' }}>
                    {(page-1)*PER+i+1}
                  </td>
                  <td>
                    <div style={{ display:'flex', alignItems:'center', gap:10 }}>
                      <div style={{ width:34, height:34, borderRadius:'50%',
                        background:'var(--gold)', color:'var(--bg)',
                        display:'flex', alignItems:'center', justifyContent:'center',
                        fontSize:'.76rem', fontWeight:800, flexShrink:0 }}>
                        {(s.name||s.email)[0].toUpperCase()}
                      </div>
                      <span style={{ fontSize:'.84rem', color:'var(--white)', fontWeight:500 }}>
                        {s.name || <span style={{ color:'var(--white40)', fontStyle:'italic', fontWeight:400 }}>No name</span>}
                      </span>
                    </div>
                  </td>
                  <td style={{ fontSize:'.82rem', color:'var(--white70)' }}>{s.email}</td>
                  <td><span className="badge badge-blue">{s.source||'website'}</span></td>
                  <td style={{ fontSize:'.78rem', color:'var(--white40)', whiteSpace:'nowrap' }}>
                    {new Date(s.createdAt).toLocaleDateString('en-US',{month:'short',day:'numeric',year:'numeric'})}
                  </td>
                  <td><span className="badge badge-green">Active</span></td>
                  <td>
                    <div className="row-actions">
                      <button title="Copy email" className="act-view"
                        onClick={() => { navigator.clipboard.writeText(s.email); addToast('Email copied','info'); }}>
                        📋
                      </button>
                      <button title="Unsubscribe" className="act-delete"
                        onClick={() => handleUnsubscribe(s._id, s.email)}>
                        🚫
                      </button>
                    </div>
                  </td>
                </tr>
              ))}
            </tbody>
          </table>
        </div>

        {pages > 1 && (
          <div className="pagination">
            <span className="pagination-info">
              Page {page} of {pages} · {filtered.length} subscribers
            </span>
            <div className="pagination-btns">
              <button className="page-btn" disabled={page===1}
                onClick={() => setPage(p=>p-1)}>‹</button>
              {Array.from({length:Math.min(pages,7)},(_,i)=>i+1).map(p=>(
                <button key={p} className={`page-btn${p===page?' active':''}`}
                  onClick={()=>setPage(p)}>{p}</button>
              ))}
              <button className="page-btn" disabled={page===pages}
                onClick={()=>setPage(p=>p+1)}>›</button>
            </div>
          </div>
        )}
      </div>

      <style>{`@keyframes pulse{0%,100%{opacity:1}50%{opacity:.4}}`}</style>
      <ToastContainer/>
    </div>
  );
}
